import { Navigate, Route, Routes } from "react-router-dom"

import { NAMES_ROUTES, PARAMS } from "@/const/routes.constants"
import { KAI_TAB_KEY } from "@/const/tab.constants"
import { GuidancePage } from "./components/pages/GuidancePage"
import { ScopePage } from "./components/pages/ScopePage"
import { SettingsPage } from "./components/pages/SettingsPage"

export const SettingsRouter = () => {
  const { SETTINGS } = NAMES_ROUTES
  const { SCOPES, KAI } = SETTINGS

  return (
    <Routes>
      <Route
        path={`/${SCOPES}/:${PARAMS.ID}/:${PARAMS.DUPLICATE_ID}?`}
        element={<ScopePage />}
      />
      <Route path="/:tab?/:needle?" element={<SettingsPage />} />
      <Route
        path={`/${KAI_TAB_KEY}/${KAI.GUIDANCE}/:${PARAMS.ID}`}
        element={<GuidancePage />}
      />
      <Route path="*" element={<Navigate to={`/${SETTINGS.ROOT}`} />} />
    </Routes>
  )
}
